/**
 * Global Constants & Configurations
 */

export const MODELS = [
    {
        id: 'claude-opus',
        provider: 'Anthropic',
        name: 'Claude Opus',
        desc: 'Most capable. Complex legal drafting.',
        apiId: 'claude-opus-4-6',
        accentColor: '#8B5CF6',
        speedDots: 3,
        cost: '$$$',
    },
    {
        id: 'claude-sonnet',
        provider: 'Anthropic',
        name: 'Claude Sonnet',
        desc: 'Balanced. Recommended for most tasks.',
        apiId: 'claude-sonnet-4-6',
        accentColor: 'var(--teal)',
        speedDots: 2,
        cost: '$$',
    },
    {
        id: 'claude-haiku',
        provider: 'Anthropic',
        name: 'Claude Haiku',
        desc: 'Fast. Routine correspondence.',
        apiId: 'claude-haiku-4-5-20251001',
        accentColor: 'var(--orange)',
        speedDots: 1,
        cost: '$',
    },
    {
        id: 'gpt-4o',
        provider: 'OpenAI',
        name: 'GPT-4o',
        desc: 'Alternative. Strong instruction-following.',
        apiId: 'gpt-4o',
        accentColor: '#10A37F',
        speedDots: 2,
        cost: '$$',
    },
];

export const TONES = ['Formal', 'Neutral', 'Client-Friendly'];

export const DEFAULT_SETTINGS = {
    customModels: MODELS,
    defaultModel: 'claude-sonnet',
    taskTemplates: [],
    instructions: {
        general: '',       // Firm history, background, house style, etc.
        toneOverrides: {   // Per-tone custom instructions keyed by tone name
            Formal: '',
            Neutral: '',
            'Client-Friendly': '',
        },
    },
};
